module.exports = __webpack_public_path__ + "img/pro_1.96b70d79.png";